import PostalMime from 'postal-mime';

const parseSesEmail = async (rawTextData) => {
  const safeRawText = rawTextData || '';
  const fallbackData = {
    from: '',
    to: '',
    replyTo: '',
    messageId: '',
    inReplyTo: '',
    references: '',
    subject: '',
    date: '',
    html: '',
    text: '',
  };

  if (!safeRawText.trim()) {
    return fallbackData;
  }

  try {
    const parsedEmail = await PostalMime.parse(safeRawText);

    const formatAddressList = (value) => {
      if (!value) {
        return '';
      }

      if (Array.isArray(value)) {
        const from = value[0];
        return `${from.name} <${from.address}>`;
      }

      return `${value.name} <${value.address}>`;
    };

    return {
      from: formatAddressList(parsedEmail.from),
      to: formatAddressList(parsedEmail.to),
      replyTo: formatAddressList(parsedEmail.replyTo),
      messageId: parsedEmail.messageId || '',
      inReplyTo: parsedEmail.inReplyTo || '',
      references: parsedEmail.references || '',
      subject: parsedEmail.subject || '',
      date: parsedEmail.date instanceof Date ? parsedEmail.date.toUTCString() : (parsedEmail.date || ''),
      html: parsedEmail.html || '',
      text: parsedEmail.text || '',
    };
  } catch (error) {
    console.error('Failed to parse SES email with PostalMime', error);

    return fallbackData;
  }
};

export default parseSesEmail;
